import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Lottery} from '../../models';
import {TicketQuota} from '../../models';
import {environment} from '~environments/environment';

/**
 * Service for creating and updating ticket quota entity.
 */
@Injectable({
  providedIn: 'root'
})
export class TicketQuotaService {
  public API_URL: any = environment.envAPI;
  public currentTicketQuota: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public castCurrentTicketQuota: any = this.currentTicketQuota.asObservable();

  constructor(private http: HttpClient) {
  }

  /**
   * Get ticket quota.
   */
  public get(lottery: Lottery): Observable<TicketQuota> {
    return this.http.get<TicketQuota>(`${this.API_URL}/l/lotteries/${lottery.id}/submission-setup/${lottery.submissionSetup.id}/ticket-quota-constraint`).pipe(
      map(res => new TicketQuota(res))
    );
  }

  /**
   * Update ticket quota.
   */
  public update(ticketQuota: TicketQuota): Observable<TicketQuota> {
    return this.http.patch<TicketQuota>(`${this.API_URL}/l/ticket-quota-constraints/${ticketQuota.id}`, ticketQuota).pipe(
      map(res => new TicketQuota(res))
    );
  }

  /**
   * Adds values to the observer.
   */
  public setCurrentTicketQuota(ticketQuota: TicketQuota): void {
    this.currentTicketQuota.next(ticketQuota);
  }
}
